



























































import { Component, Prop, Vue } from 'vue-property-decorator';
import { menuServe, userManagementServe } from '@/api/installServer';

@Component({
  components: {},
})
export default class AddUser extends Vue {
  @Prop(Object) row!: any; // 传递给编辑页面-数据对象
  private title: any = ''; // dialog 标题
  private pwd: any = ''; // 原始密码
  scrollbar = true;

  // 表单数据
  private formData: any = {
    id: '',
    oldPassword: '',
    newPassword: '',
    username: '',
  };
  // 表单验证规则
  formRules: object = {
    oldPassword: [
      { required: true, message: '请输入旧密码', trigger: 'blur' },
      { max: 32, message: '长度最大为32个字符', trigger: 'blur' },
      { validator: this.validateOldPassword, trigger: 'blur' },
    ],
    newPassword: [
      { required: true, message: '请输入新密码', trigger: 'blur' },
      { max: 32, message: '长度最大为32个字符', trigger: 'blur' },
      { validator: this.validatePassword, trigger: 'blur' },
    ],
  };

  /**
   @description: 初始化接收父组件点击行内编辑时传的参
   @author: cxf
   @update: cxf 2021/5/19 12:23
   **/
  created() {
    const data: any = this.row;
    this.title = '修改密码';
    // this.formData = data;
    this.formData.id = data.id;
    // this.formData.oldPassword = data.password;
    this.formData.username = data.username;
    this.pwd = data.password;
  }

  mounted() {
    this.hasScrollbar();
  }

  hasScrollbar() {
    const dom: any = document.getElementById('main_box');
    this.scrollbar = dom.scrollHeight > dom.clientHeight || dom.offsetHeight > dom.clientHeight;
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 保存并提交编辑、新增
   * @param1 暂无
   * @returns 暂无
   */
  save(): void {
    const formComponent: any = this.$refs.form;
    formComponent.validate((valid: any) => {
      if (!valid) {
        return;
      }
      this.editFunctionData();
    });
  }

  /**
   * 【接口】编辑功能
   */
  private async editFunctionData() {
    userManagementServe
      .editPasswordData(this.formData)
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('密码修改成功');
          this.close(); // 返回到父级页面
        } else {
          this.$message.warning(res.msg);
        }
      })
      .catch(() => {});
  }

  /**
   * 【验证】验证用户密码
   * @Params
   * @return
   **/
  private async validateOldPassword(rule: any, value: any, callback: any) {
    const passwordReg = /^.{6,20}$/g;
    if (!passwordReg.test(value)) {
      callback(new Error('密码应由6到20个字符组成'));
    }
    // if (value !== this.pwd) {
    //     callback(new Error('旧密码输入有误，请重新输入'));
    // }
    callback();
  }

  /**
   * 【验证】验证用户密码
   * @Params
   * @return
   **/
  private async validatePassword(rule: any, value: any, callback: any) {
    const passwordReg = /^.{6,20}$/g;
    if (!passwordReg.test(value)) {
      callback(new Error('密码应由6到20个字符组成'));
    }
    if (value === this.formData.oldPassword) {
      callback(new Error('新密码与旧密码相同，请重新输入'));
    }
    callback();
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击关闭按钮，返回上一级.
   * @param1 暂无
   * @returns 暂无
   */
  close(): void {
    this.pwd = '';
    this.formData = {
      id: '',
      oldPassword: '',
      newPassword: '',
      username: '',
    };
    this.$emit('on-response');
  }
}
